/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';
import { makeTree } from '../helpers/savedSearches';

export const search = createAsyncThunk('savedSearches/search', async (value, { getState }) => {
  const userId = getState().user._id;
  return { value, userId };
});

export const reducer = (builder) => {
  builder.addCase(
    search.fulfilled,
    (state, { payload: { value, userId } }) => {
      state.searchQuery = value;
      state.tree = makeTree(state.all, userId, value);
    },
  );
};
